var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-wrapper"},[(_vm.company_logo)?_c('div',{staticClass:"company-logo"},[_c('img',{attrs:{"src":_vm.company_logo}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$tr('interview.landing.modules.feniche.title')))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }